import { isMobile } from './isMobile';
import { isTablet } from './isTablet';

export const isMobileOnly = () => isMobile() && !isTablet();
